<div id="map1" class="mapboxgl-map"></div>

